import { owned } from "./handles.js";
import { assertOwner, freezeEntries, safePriority, validId } from "./validation.js";
export function createUpgrade(id, options, owner, numbers) {
    validId(id, "upgrade");
    assertOwner(options.scope, owner, `Scope for ${id}`);
    return owned({
        ...options,
        id,
        costs: freezeEntries(options.costs ?? [], owner, numbers, id),
        prerequisiteIds: Object.freeze([...options.prerequisiteIds]),
    }, owner);
}
export function createPrestige(id, options, owner) {
    validId(id, "prestige");
    assertOwner(options.scope, owner, `Scope for ${id}`);
    assertOwner(options.reward, owner, `Reward for ${id}`);
    validateManifest(options.manifest, owner, id);
    if (options.manifest.clear.length === 0)
        throw new TypeError(`Prestige ${id} clears no scopes`);
    return owned({
        ...options,
        id,
        manifest: Object.freeze({
            clear: Object.freeze([...options.manifest.clear]),
            ...(options.manifest.retain === undefined ? {} : { retain: options.manifest.retain }),
        }),
        prerequisiteIds: Object.freeze([...(options.prerequisiteIds ?? [])]),
    }, owner);
}
export function createTrigger(id, options, owner) {
    validId(id, options.kind);
    assertOwner(options.scope, owner, `Scope for ${id}`);
    const priority = safePriority(options.priority, id);
    return owned({ ...options, id, priority }, owner);
}
export function createChallenge(id, options, owner) {
    validId(id, "challenge");
    assertOwner(options.scope, owner, `Scope for ${id}`);
    validateManifest(options.enterReset, owner, id);
    validateManifest(options.exitReset, owner, id);
    if (!Number.isSafeInteger(options.maxCompletions) || options.maxCompletions < 1)
        throw new TypeError(`Challenge ${id} requires a positive safe completion limit`);
    const countsAs = uniqueIds(options.countsAs ?? [], `Challenge ${id} countsAs`);
    const replacementKeys = uniqueIds(options.replacementKeys ?? [], `Challenge ${id} replacement`);
    return owned({ ...options, id, countsAs, replacementKeys }, owner);
}
export function createAutomation(id, options, owner) {
    validId(id, "automation");
    assertOwner(options.scope, owner, `Scope for ${id}`);
    const priority = safePriority(options.priority, id);
    if (!Number.isSafeInteger(options.cadenceMs) || options.cadenceMs < 1)
        throw new TypeError(`Cadence for ${id} must be a positive safe integer`);
    return owned({ ...options, id, priority }, owner);
}
function validateManifest(manifest, owner, id) {
    for (const scope of manifest.clear)
        assertOwner(scope, owner, `Reset scope for ${id}`);
    for (const value of [
        ...(manifest.retain?.resources ?? []),
        ...(manifest.retain?.buyables ?? []),
        ...(manifest.retain?.allocations ?? []),
        ...(manifest.retain?.upgrades ?? []),
        ...(manifest.retain?.triggers ?? []),
        ...(manifest.retain?.challenges ?? []),
        ...(manifest.retain?.automation ?? []),
    ]) {
        assertOwner(value, owner, `Retention for ${id}`);
    }
}
function uniqueIds(values, label) {
    for (const value of values)
        validId(value, label);
    if (new Set(values).size !== values.length)
        throw new TypeError(`${label} values must be unique`);
    return Object.freeze([...values]);
}
//# sourceMappingURL=progression-builders.js.map